<template>
  <div class="admin">
    <div>
      <div @click="$router.push('/admin/teacherList')">
        <div>
          <img src="../assets/image/classList.png" />
        </div>
        <div>
          老師列表
        </div>
      </div>

      <div @click="$router.push('/admin/studentList')">
        <div>
          <img src="../assets/image/studentList.png" />
        </div>
        <div>
          學生列表
        </div>
      </div>

      <div @click="$router.push('/admin/courseList')">
        <div>
          <img src="../assets/image/classList.png" />
        </div>
        <div>
          課程列表
        </div>
      </div>

      <div @click="$router.push('/admin/classList')">
        <div>
          <img src="../assets/image/studentList.png" />
        </div>
        <div>
          班級列表
        </div>
      </div>

      <div @click="$router.push('/admin/analysis')">
        <div>
          <img src="../assets/image/studentList.png" />
        </div>
        <div>
          統計數據
        </div>
      </div>

      <div @click="$router.push('/admin/noticeboard')">
        <div>
          <img src="../assets/image/classList.png" />
        </div>
        <div>
          發布公告
        </div>
      </div>

      <div @click="$router.push('/admin/loginWatch')">
        <div>
          <img src="../assets/image/studentList.png" />
        </div>
        <div>
          登入分析
        </div>
      </div>

      <div @click="$router.push('/admin/cwhunt')">
        <div>
          <img src="../assets/image/classList.png" />
        </div>
        <div>
          解題數曲線
        </div>
      </div>

      <div @click="$router.push('/admin/grade')">
        <div>
          <img src="../assets/image/classList.png" />
        </div>
        <div>
          解題評分
        </div>
      </div>

      <!-- <div @click="$router.push('/admin/analysis/enrollment')">
        <div>
          <img src="../assets/image/classList.png" />
        </div>
        <div>
          報名狀況
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.admin {
  > div {
    display: flex;
    flex-wrap: wrap;
    padding: 55px 8%;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    > div {
      width: calc((100% - 90px) / 4);

      @media (max-width: 768px) {
        width: 100%;
      }

      @media (min-width: 769px) and (max-width: 1024px) {
        width: calc((100% - 30px) / 2);

        &:nth-child(2n + 2) {
          margin-right: 0;
        }
      }

      border-radius: 20px;
      box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.5);
      border: solid 3px #000000;
      background-color: #ffffff;
      padding: 20px;
      transition: all .3s;
      cursor: pointer;
      margin-right: 30px;
      margin-bottom: 30px;

      &:hover {
        transition: all .3s;
        background: $main-yellow;
      }

      &:nth-child(4n + 4) {
        margin-right: 0;
      }

      > div {
        &:first-child {
          text-align: center;
          border-bottom: 1px solid #000;
          img {
            width: 85%;
          }
        }

        &:nth-child(2) {
          font-size: 30px;
          text-align: center;
          color: #000;

          padding: 20px 0 10px;
        }
      }
    }
  }
}
</style>
